import Service from '../../plunk/service/service';
import { AuthBase } from '../../plunk/service/auth-base';
import endpoints from '../endpoints';
import account from '../data/account';
import { refreshTokens as cognitoRefresh } from '../auth/cognito';
import { isSsoMode, fetchSsoSession, ssoEligible, redirectToCentralLogin } from '../auth/sso';

// Register the refresh handler for every Service subclass. AuthBase calls
// this whenever a 401 fires. Two paths:
//   SSO mode (signed in via auth.plunk.io broker) → the broker refreshes;
//     the Cognito refresh token lives server-side, not in this browser.
//   Direct mode (localhost dev) → raw Cognito REFRESH_TOKEN_AUTH.
if (typeof AuthBase.refreshHandler === 'undefined' || !AuthBase.refreshHandler) {
  AuthBase.refreshHandler = async refreshToken => {
    if (isSsoMode()) {
      const session = await fetchSsoSession();
      if (!session) {
        const err = new Error('SSO session expired');
        err.statusCode = 401;
        throw err;
      }
      return {
        idToken: session.idToken,
        accessToken: session.accessToken,
        refreshToken: null,
        expiresAt: session.expiresAt
      };
    }
    return cognitoRefresh(refreshToken);
  };
}
export default class ServiceFactory {
  static getType(api, type = 'activity') {
    class FService extends Service {}
    FService.rootEndpoint = endpoints[type].root + api;

    // Tenant header — sourced from JWT claims (parsed inside account.get).
    // Falls back to the legacy LocalCache entry if no token yet.
    var accountData = account.get();
    var tenantId = accountData ? accountData.tenantId : null;
    if (tenantId) {
      FService.account = tenantId;
      FService.headers = ['x-app-id:' + tenantId];
    }

    // Refresh failure (expired refresh token) → force re-auth. On
    // *.plunk.io go to central login (auth.plunk.io) with a ?redirect back
    // to the current deep link; localhost uses the app's own form
    // (remembering the deep link in sessionStorage).
    FService.onAuthTokenFailure = (err, callback) => {
      callback(err, null);
      FService.removeTokens();
      if (ssoEligible()) {
        redirectToCentralLogin(location.origin + location.pathname + location.search);
        return;
      }
      try {
        if (!/^\/Auth\//i.test(location.pathname)) {
          sessionStorage.setItem('plunkReturnUrl', location.pathname + location.search);
        }
      } catch (e) {/* ignore */}
      location.href = '/Auth/SignIn';
    };
    return FService;
  }
}